<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;background-color: #fff;">
			<div class="headerBox">
				<div class="hearderContentBox">
					<div class="titleBox" @click="goMore('/')">
						<div class="logoBox">
							<img :src="getImg(all_logo)" alt="">
						</div>
						<span style="margin-left: 10px;">{{ platformName }}</span>
					</div>
				</div>
			</div>

		</div>
		<div style="width: 1200px;min-height:556px;margin: 20px auto 116px;">
			<a-card>
				<a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
					<a-form-item label="提交时间" name="companyName">
						<range-picker v-model:startDate="searchForm.startDate" v-model:endDate="searchForm.endDate" />
					</a-form-item>
					<div class="hidden">
						<a-form-item label="companyCode" name="companyCode">
							<a-input style="width:100%" v-model:value="searchForm.companyCode" />
						</a-form-item>
					</div>
					<a-form-item label="申请进度" name="schedule">
						<a-select v-model:value="searchForm.schedule" placeholder="请选择审核状态">
							<a-select-option value="0">申请中</a-select-option>
							<a-select-option value="1">通过</a-select-option>
							<a-select-option value="2">不通过</a-select-option>
							<a-select-option value="3">印章刻制中</a-select-option>
							<a-select-option value="4">印章刻制完成</a-select-option>
							<a-select-option value="5">初审通过</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item>
						<a-button type="primary" @click="onSearch">查询</a-button>
						<a-button @click="onReset">重置</a-button>
					</a-form-item>
				</a-form>
				<a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
					<template #message>
						已选择 {{ selectedRowKeys.length }} 项
						<a @click="onClearSelected" class="ml-20 float-right">清空</a>
					</template>
				</a-alert>
				<a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
					:pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
					<template #companyName="{ record }">
						<a @click="onDetail(record)">{{ record.companyName }}</a>
					</template>
					<template #schedule="{ record }">
						<span v-if="record.schedule == 0">申请中</span>
						<!-- <span style="color:red" v-if="record.schedule==1">未通过</span> -->
						<a-popover v-if="record.schedule == 1" placement="bottom">
							<template #content v-if="record.remark">
								<p>{{ record.remark }}</p>
							</template>
							<template #title>
								<span>未通过原因</span>
							</template>
							<a style="color:red">未通过</a>
						</a-popover>
						<span style="color:#036F31" v-if="record.schedule == 2">已通过</span>
						<span style="color:gold" v-if="record.schedule == 3">印章刻制中</span>
						<span style="color:#87d068" v-if="record.schedule == 4">印章刻制完成</span>
						<span style="color:#036F31" v-if="record.schedule == 5">初审通过</span>
					</template>
					<template #collectionMethod="{ record }">
						<span v-if="record.collectionMethod == 0">自取</span>
						<span v-if="record.collectionMethod == 1">邮寄</span>
					</template>
					<template #submitTime="{ record }">
						<span :class="{ clred: !record.submitTime }">{{ record.submitTime ? record.submitTime.split(' ')[0] :
							'未提交' }}</span>
					</template>
					<template #action="{ record }">
						<a @click="onDetail(record)">详情 </a>
						<a v-if="record.isSubmit == 0" @click="onEdit(record)"> 编辑</a>
						<!-- <a v-if="record.isSubmit==0" @click="onSubmit(record)"> 提交</a> -->
					</template>
				</a-table>
			</a-card>
		</div>
		<LayoutFooter  />
	</div>
	<Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel" />
</template>

<script>
import { dictMixin } from "@/mixins";
// import { ls } from "@/utils/util"
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import dataCheck from "@/utils/dataCheck";
import { common, phoneCommon } from "@/api/finance"
import { notification } from "ant-design-vue";
import { file_service, register_mp } from "@/api/adminService";
import { companyInfo } from '@/api/companyService';
// import Detail from "./components/Detail";
import Detail from "./components/DetailModal";
import { tableListMixin } from "@/mixins";
import { enterpriseEngraveApply } from "@/api/EnterpriseSealService";
import { dateFormat } from "@/config/variableConfig";

const columns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	// {title: "企业名称", dataIndex: "companyName", key: "companyName", slots: {customRender: "companyName"},width: "150px"},
	// {title: "经办人", dataIndex: "agent", key: "agent"},
	{ title: "领取方式", dataIndex: "collectionMethod", key: "collectionMethod", slots: { customRender: "collectionMethod" } },
	// {title: "是否为新办市场主体", dataIndex: "isMarket", key: "isMarket", slots: {customRender: "isMarket"}},
	// {title: "是否个转企", dataIndex: "isEnterprise", key: "isEnterprise", slots: {customRender: "isEnterprise"}},
	// {title: "邮寄地址", dataIndex: "mailingAddress", key: "mailingAddress",width: "150px"},
	{ title: "提交时间", dataIndex: "submitTime", key: "submitTime", slots: { customRender: "submitTime" } },
	{ title: "申请进度", dataIndex: "schedule", key: "schedule", slots: { customRender: "schedule" } },
	// {title: "缴税总额", dataIndex: "totalTax", key: "totalTax"},
	{ title: "操作", fixed: 'right', dataIndex: "action", key: "action", slots: { customRender: "action" }, width: "150px" },
];
export default {
	name: "信息补充",
	mixins: [tableListMixin, dictMixin],
	components: {
		Detail,
		LayoutFooter,
	},
	data() {
		return {
			waitTime: 61,
			all_logo: '',
			// dictNames: 'policy_type',
			user: {},
			formState: {
				user: undefined,
			},
			webSiteInfo: {},
			linkData: [],
			pwOk: null,
			companyShow: null,
			optionsRoleTreeList: null,
			optionsMechanIsmTreeList: null,
			optionsBaseTreeTreeList: null,
			optionsTreeList: null,
			codeLength: 4,
			inputvalue: '',
			show: false,
			showerror: false,
			platformName,
			confirmLoading: false,
			codeBtnWord: '获取短信验证码',
			form: {
				phoneNumber: null,
				password: null,
				watmal: null,
				newpassword: null,
				// captcha: null,
			},
			rules: {
				phoneNumber: [
					dataCheck.required({ msg: '手机号不能为空' }), dataCheck.mobile_phone
				],
				newpassword: [
					dataCheck.required({ msg: '用户名不能为空' }), dataCheck.password,
				],
				password: [
					dataCheck.required({ msg: '密码不能为空' }),
				],
				watmal: [
					dataCheck.required({ msg: '短信验证码不能为空' }),
				]
				// captcha: [
				//     dataCheck.required({msg: '验证码不能为空'}),
				// ],
			},
			captchaPath: '',
			redirectPath: '/',

			dateFormat,
			dictNames: 'isPublic,serviceStatus,condition,demand_type',
			columns,
			queryParam: {
				companyCode: this.$route.query.id
			},
			listUrl: enterpriseEngraveApply.pageList,
			listKeyField: "id",
			deleteUrl: enterpriseEngraveApply.remove
		}
	},


	methods: {
		getPhoneCode() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((value) => {
					this.postAction({
						url: phoneCommon.retrievePwd,
						params: {
							phone: value.phoneNumber
						}
					}
					).then((res) => {
						if (res.code == '0') {
							this.waitTime = (res.msg * 60) + 1
							this.waitTime--;
							this.$refs.codeBtnWordMarkid.style.zIndex = 1
							this.codeBtnWord = `${this.waitTime}s 后获取`;
							let timer = setInterval(() => {
								if (this.waitTime > 1) {
									this.waitTime--;
									this.codeBtnWord = `${this.waitTime}s 后获取`;
								} else {
									clearInterval(timer);
									this.codeBtnWord = "获取短信验证码";
									this.$refs.codeBtnWordMarkid.style.zIndex = -1
									this.waitTime = 61;
								}
							}, 1000);
							notification.success({
								message: '验证码发送成功，请查看手机短信',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '验证码发送失败，请稍后重新发送',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
					})
				})
		},
		getCode() {

			this.$refs.ruleForm
				.validate('phoneNumber')
				.then(() => {
					this.postSeed()
					// this.waitTime--;
					// this.$refs.codeBtnWordMarkid.style.zIndex = 1
					// this.postSeed()
					// this.codeBtnWord = `${this.waitTime}s 后获取`;
					// let timer = setInterval(() => {
					// 	if (this.waitTime > 1) {
					// 		this.waitTime--;
					// 		this.codeBtnWord = `${this.waitTime}s 后获取`;
					// 	} else {
					// 		clearInterval(timer);
					// 		this.codeBtnWord = "获取邮箱验证码";
					// 		this.$refs.codeBtnWordMarkid.style.zIndex = -1
					// 		this.waitTime = 61;
					// 	}
					// }, 1000);
				})
				.catch(() => {
				})
		},

		postSeed() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((values) => {
					this.confirmLoading = true;
					this.postAction({
						url: common.sendCode,
						params: {
							mobilePhone: values.phoneNumber,
						}
					}
					).then((res) => {
						if (res.code == '0') {
							notification.success({
								message: '验证码发送成功，请查看邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '邮箱不存在，请联系平台管理员补充邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: '今日验证码已达上限，24小时后重新申请',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: '邮箱功能未开通，联系管理员设置',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '4') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
						this.confirmLoading = false;
						// this.$router.push(this.redirectPath);
					}).catch((err) => {
						console.log(err, 'err')
						this.confirmLoading = false;
					})
				})
				.catch(() => {
				})
		},

		getNew(e) {
			if (e.target.value != this.form.newpassword) {
				this.pwOk = false
			} else {
				this.pwOk = true
			}
		},
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},

		subPhone() {
			var valiSome = ['phoneNumber']
			this.$refs.ruleForm.validate(valiSome).then(() => {
				this.getAction({
					url: register_mp.verifyUniquePhone,
					params: {
						phoneNumber: this.form.phoneNumber
					}
				}
				).then((res) => {
					if (res) {
						this.$notification.error({
							message: '该手机号未注册！',
							duration: 10,
							style: {
								width: '400px',
								fontWeight: '600',
								marginTop: `${10}%`,
							},
						});
					} else {
						this.getPhoneCode()
						this.$notification.success({
							message: ('手机号可用，请继续操作！'),
							duration: 10,
							style: {
								width: '400px',
								fontWeight: '600',
								marginTop: `${10}%`,
							},
						});
					}
				})
			})
		},
		getTableData(id) {
			this.getAction({
				url: enterpriseEngraveApply.queryData,
				params: {
					companyCode: id,
				}
			}).then(res => {
				this.dataSource = res
			})
		},
		onAdd() {
			this.getAction({
				url: companyInfo.detail
			}).then(res => {
				if (res.companyName && res.oraganizationCode && res.detailedAddress && res.corporation) {
					this.$router.push({ path: '/EnterpriseSealService/Add' })
				} else {
					this.$message.warning('请完善企业基本信息！')
					this.$router.push({ path: '/companyInfo' })
				}
			})
		},
		onEdit(record) {

			this.$router.push({ path: '/EnterpriseSealService/Add', query: { id: record.id } })
			// this.getAction({
			//     url: enterpriseEngraveApply.detail,
			//     params: {id: record.id}
			// }).then(() => {
			//     this.$router.push({path: '/sys/EnterpriseSealService/Add', query: {id: record.id}})
			// })
		},
		onSubmit(record) {
			this.postAction({
				url: enterpriseEngraveApply.submit,
				params: {
					id: record.id,
					isSubmit: 1
				}
			}).then(res => {
				if (res) {
					this.loadData();
				}
			})
		},
		onDetail(record) {
			this.getAction({
				url: enterpriseEngraveApply.detail,
				params: { id: record.id }
			}).then(res => {
				this.onShowModal("detailmodal", res)
			})
		},

		exportExcelTemplate0() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal0,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.download = decodeURIComponent('刻章刻制流转单模板');// 文件重命名，若无需重命名，将该行删去
				link.click();
			})
		},
		exportExcelTemplate1() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal1,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.download = decodeURIComponent('刻章备案登记表模板');// 文件重命名，若无需重命名，将该行删去
				link.click();
			})
		},
		exportExcelTemplate2() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal2,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.download = decodeURIComponent('刻章委托书模板');// 文件重命名，若无需重命名，将该行删去
				link.click();
			})
		},
	},

	mounted() {
		this.all_logo = this.$ls.get('all_logo');
		this.getTableData(this.$route.query.id)
	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>

<style scoped lang="less">
.clred {
	color: red
}

.codeBtnWordMark {
	width: 100%;
	height: 40px;
	background: rgba(136, 135, 135, 0.6);
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
}

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 250px;
		background-image: url('../../assets/img/resigter.jpg');
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;

		.text {
			font-size: 30px;
			color: #fff;
			font-weight: 700;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -40px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}

					.btnBB {
						width: 300px;
						margin: 0 auto;
					}

					:deep(.ant-form-item-label > label) {
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

.footerBox {
	width: 100%;
	background-color: #333333;

	.footerContent {
		position: relative;
		margin: 0 auto;
		padding: 24px 0;
		width: 1200px;

		.firstLine {
			padding: 8px 0;
			font-size: 14px;
			color: #999;

			span {
				margin-right: 18px;
			}
		}

		.footCode {
			position: absolute;
			right: 0;
			bottom: 12%;
			text-align: center;

			.footEwm {
				margin-bottom: 8px;
			}

			.footEwmTitle {
				color: #999;
			}
		}
	}
}

:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}
</style>
